import React, { useState, useEffect } from "react";
import axios from "axios";

const MyCourseLinks = ({ platformUrl }) => {
    const [links, setLinks] = useState([]);
    const [readLinks, setReadLinks] = useState({});
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const courseUuid = params.get("courseUuid");

    useEffect(() => {
        if (!token || !courseUuid) {
            setError("Missing access token or course UUID. Please try again.");
            setLoading(false);
            return;
        }

        const fetchHtmlLinks = async () => {
            try {
                const courseResponse = await axios.get(
                    `${platformUrl}/learn/api/public/v3/courses/uuid:${courseUuid}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                const courseId = courseResponse.data.id;

                const allLinks = [];

                const fetchContentsRecursively = async (parentId = "ROOT") => {
                    const response = await axios.get(
                        `${platformUrl}/learn/api/public/v1/courses/${courseId}/contents?parentId=${parentId}`,
                        { headers: { Authorization: `Bearer ${token}` } }
                    );

                    for (const item of response.data.results) {
                        if (item.contentHandler?.id === "resource/x-bb-externallink") {
                            allLinks.push({
                                id: item.id,
                                title: item.title,
                                url: item.contentHandler?.url,
                            });
                        }
                        if (item.hasChildren) {
                            await fetchContentsRecursively(item.id);
                        }
                    }
                };

                await fetchContentsRecursively();

                setLinks(allLinks);

                const initialReadState = {};
                allLinks.forEach(link => {
                    initialReadState[link.id] = false;
                });
                setReadLinks(initialReadState);

            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchHtmlLinks();
    }, [platformUrl, courseUuid, token]);

    const markAsRead = (linkId) => {
        setReadLinks(prev => ({
            ...prev,
            [linkId]: true
        }));
    };

    if (loading) {
        return <div style={{ padding: "16px" }}>Loading course links...</div>;
    }

    if (error) {
        return (
            <div style={{ padding: "16px", color: "red" }}>
                <h2>Error</h2>
                <p>{error}</p>
                <p>Please check your access token or course UUID and try again.</p>
            </div>
        );
    }

    return (
        <div style={{ padding: "16px" }}>
            <h1 style={{ marginBottom: "16px" }}>Course HTML Links</h1>
            {links.length === 0 ? (
                <p>No HTML links found in this course.</p>
            ) : (
                <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                    {links.map((link) => (
                        <li
                            key={link.id}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: '8px'
                            }}
                        >
                            <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: "8px" }}
                            >
                                {link.title}
                            </a>
                            {!readLinks[link.id] ? (
                                <span
                                    style={{
                                        color: "orange",
                                        cursor: "pointer",
                                        textDecoration: "underline"
                                    }}
                                    onClick={() => markAsRead(link.id)}
                                >
                                    TODO: Read article
                                </span>
                            ) : (
                                <span style={{ color: "green", fontWeight: "bold" }}>✓ Read</span>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default MyCourseLinks;
